import { render } from "./CartProduct.vue?vue&type=template&id=4a0179b2&scoped=true"
import script from "./CartProduct.vue?vue&type=script&lang=js"
export * from "./CartProduct.vue?vue&type=script&lang=js"

import "./CartProduct.vue?vue&type=style&index=0&id=4a0179b2&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\bdroyelculture-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a0179b2"]])

export default __exports__